import React, { useState } from 'react';
import styles from './EmailForm.module.css'

const EmailForm: React.FC = () => {
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [isSending, setIsSending] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSending(true);
    setSuccessMessage('');

    await new Promise((resolve) => setTimeout(resolve, 1000));
    try {
      const response = await fetch('https://api-prod.spoteet.fr/users/v1/landing/support', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          subject,
          message,
        }),
      });

      if (!response.ok) {
        throw new Error('Erreur lors de l’envoi du message');
      }

      setSuccessMessage('Email envoyé');
      setEmail('');
      setSubject('');
      setMessage('');
    } catch (error) {
      console.error(error);
      setSuccessMessage('Une erreur est survenue. Veuillez réessayer.');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div style={{ maxWidth: '500px', marginTop: '2rem' }}>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '1rem' }}>
          <label>Email :</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className={styles.emailFormInput}
          />
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <label>Objet :</label>
          <input
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            required
            className={styles.emailFormInput}
          />
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <label>Message :</label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
            rows={5}
            className={styles.emailFormTextArea}
          />
        </div>

        <button
          type="submit"
          disabled={isSending}
          style={{
            cursor: isSending ? 'not-allowed' : 'pointer',
          }}
          className={styles.buttonEmailForm}
        >
          {isSending ? 'Envoi...' : 'Envoyer'}
        </button>

        {successMessage && (
          <p  className={styles.successMessage}>
            {successMessage}
          </p>
        )}
      </form>
    </div>
  );
};

export default EmailForm;
